import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// import commonEn from '~system/locales/en/common.json';
// import leaseEn from '~system/locales/en/modules/lease.json';

const allTranslations = {
  // ...commonEn,
  // ...leaseEn,
};

export type TranslationKeys = keyof typeof allTranslations;

const resources = {
  en: {
    translation: {},
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    debug: true,
  });

export default i18n;
